import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

const AuthErrorModal = ({ open, onClose, errorMessage }) => {

  return (
    <Dialog
      open={open}
      onClose={onClose}
      disableEscapeKeyDown={false} // Permite fechar com ESC
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          padding: 2,
        },
      }}
    >
      <DialogTitle>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <ErrorOutlineIcon color="error" fontSize="large" />
          <Typography variant="h5" component="span" fontWeight="bold">
            Erro na Autenticação
          </Typography>
        </Box>
      </DialogTitle>
      
      <DialogContent>
        <Typography variant="body1" sx={{ mb: 2 }}>
          Ocorreu um erro durante o processo de autenticação.
        </Typography>
        {errorMessage && (
          <Typography variant="h3" color="text.secondary" sx={{ mb: 2 }}>
            Detalhes: {errorMessage}
          </Typography>
        )}
        <Typography variant="body1">
          Você será redirecionado para fazer login novamente.
        </Typography>
      </DialogContent>
      
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button 
          onClick={onClose} 
          variant="contained" 
          color="primary"
          fullWidth
          sx={{ py: 1.5 }}
        >
          Entendi
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AuthErrorModal;